// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3CTZH","col":"styles_col__QpM1t","fulfillmentStatus":"styles_fulfillmentStatus__2AYYS","emailCol":"styles_emailCol__TSbbn"};